import type { FormControl } from '@angular/forms';
import { type ValidatorFn } from '@angular/forms';
import { bothOrNoneRequired } from './both-or-none-required.validator';

export function bothOrNoneRequiredToString(
  field1: FormControl<string | null>,
  field2: FormControl<string | null>,
): ValidatorFn {
  return bothOrNoneRequired(field1, field2, value => value !== '');
}
